// extracted by mini-css-extract-plugin
module.exports = {"Locations":"Locations_Locations__17ZmI","Container":"Locations_Container__nAyJ5","Wrapper":"Locations_Wrapper__3X9W4","List":"Locations_List__2kF8h"};